const E164_PATTERN = /^\+[1-9]\d{7,14}$/;
const PHONE_SEPARATORS = /[\s().-]/g;
const NANP_COUNTRY_CODES = ['US', 'CA'];
const NANP_LOCAL_NUMBER = /^[2-9]\d{9}$/;
const NANP_WITH_TRUNK_PREFIX = /^1[2-9]\d{9}$/;

export function isE164(phone: string): boolean {
    return E164_PATTERN.test(phone);
}

// Returns '' whenever the number can't be read one way only, leaving it for the admin to type.
export function toE164(raw: string, countryCode: string): string {
    const compact = raw.trim().replace(PHONE_SEPARATORS, '');
    if (isE164(compact)) return compact;
    if (!NANP_COUNTRY_CODES.includes(countryCode)) return '';
    if (NANP_LOCAL_NUMBER.test(compact)) return `+1${compact}`;
    if (NANP_WITH_TRUNK_PREFIX.test(compact)) return `+${compact}`;
    return '';
}
